import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import PropTypes from "prop-types";

/**
 * Return a autocomplete with the licenses options updated for the group user,
 * @param {array} licenses - The array of licenses available in the group
 * @param {function} onChange - Function to be executed on select a new value.
 * @param {object, string} licenseId - The value/label of the license.
 * @param {string} licenseType - The type of the current license.
 * @returns {JSX.Element}
 */
function LicensesSelector({licenses, onChange, licenseId, licenseType}) {
  // On load licencesId is a string but on change licencesId is an object.
  licenseId = licenseId ? (licenseId.value || licenseId) : undefined;

  const [licensesOptions, setLicensesOptions] = useState([]);
  const [currentLicense, setCurrentLicense] = useState(null);

  useEffect(()=>{
    let selectedLicense = licenses.find(license => license.value === licenseId);

    if(licenseId && !selectedLicense) {
      // Pushing current license into options.
      licenses.unshift({ value: licenseId, label: licenseType});
    }

    setLicensesOptions(
        licenses.map((license) => ({ value: license.value, label: license.label }))
    );
  },[licenses, licenseId, licenseType])

  useEffect(()=>{
    setCurrentLicense(licenses.find(license => license.value === licenseId) ?? null)
  },[licensesOptions, licenses, licenseId])

  return (
      <Autocomplete
          options={licensesOptions}
          noOptionsText={'Loading...'}
          label={'Licenses'}
          id={'licenses'}
          value={ currentLicense }
          onChange={(event, newValue) => {
            setCurrentLicense(newValue)
            onChange(newValue);
          }}
          renderOption={(props, option) => {
            return (
                <li {...props} key={props.id}>
                  {option.label}
                </li>
            );
          }}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          renderInput={(params) => (
              <TextField {...params} error={!Boolean(currentLicense)}/>
          )}
      />
  )

}

LicensesSelector.propTypes = {
  licenses: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  licenseId: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string,
  ]),
  licenseType: PropTypes.string
}

export default LicensesSelector
